import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Navigate } from 'react-router-dom';
import PasswordInput from '../components/common/PasswordInput';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [sessionMessage, setSessionMessage] = useState('');
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const storedMessage = localStorage.getItem('sessionExpiredMessage');
    if (storedMessage) {
      setSessionMessage(storedMessage);
      localStorage.removeItem('sessionExpiredMessage');
    }
  }, []);

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSessionMessage('');
    const success = await login(username, password);
    if (success) {
      navigate('/');
    } else {
      setError('Неверный логин или пароль.');
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '50px auto', padding: '20px', border: '1px solid #ccc', borderRadius: '5px' }}>
      <h2>Вход в Kommunalka</h2>
      {sessionMessage && (
        <div style={{ padding: '10px', marginBottom: '15px', backgroundColor: '#fff3cd', color: '#856404', border: '1px solid #ffeaa7', borderRadius: '4px' }}>
          {sessionMessage}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '10px' }}>
          <label htmlFor="username">Email:</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
          />
        </div>
        <div style={{ marginBottom: '15px' }}>
          <label htmlFor="password">Пароль:</label>
          <PasswordInput
            id="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
          />
        </div>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <button type="submit" style={{ padding: '10px 15px', cursor: 'pointer' }}>Войти</button>
      </form>
      <div style={{ marginTop: '15px', textAlign: 'center' }}>
        <button
          onClick={() => navigate('/register')}
          style={{ background: 'transparent', border: 'none', color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
        >
          Регистрация
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
